import { EPdlStatus } from "@/types/backoffice/dto/site/site-pdl-dto.ts";

const deliveryPointLocale = {
  deliveryPoint: {
    title: "Point de livraison",
    deliveryPoint: "Point de livraison",
    deliveryPointNumber: "Numéro du point de livraison",
    deliveryPointInformation: "Informations relatives au point de livraison",
    noDeliveryPoint: "Pas de point de livraison",
    consent: "Consentement",
    subscription: "Abonnement",
    nonEligible: "Non éligible",
    subscribed: "Abonné (Dernière récéption {lastReception})",
    inProgress: "En cours",
    validateDeliveryPoint: "Valider le PDL manuellement",
    invalidateDeliveryPoint: "Invalider le PDL manuellement",
    updateDeliveryPoint: "Modifier le PDL",
    searchDeliveryPoint: "Recherche d'un PDL",
    contractOwnerName: "Nom du titulaire du contrat d'électricité",
    searchTypeManual: "Saisie manuelle",
    errorDeliveryPointName: "Le nom du PDL ne peut contenir que des chiffres et des lettres",
    errorDeliveryPointRequired: "Le PDL est obligatoire",
    status: {
      [EPdlStatus.VALID]: "Validé",
      [EPdlStatus.FORCED_VALID]: "PDL validé par Voltalis",
      [EPdlStatus.PROCESSING]: "Validation en cours",
      [EPdlStatus.FORCED_INVALID]: "PDL invalidé par Voltalis",
      [EPdlStatus.INVALID]: "PDL invalide",
      [EPdlStatus.NOT_ENEDIS]: "Hors périmètre de validation",
      [EPdlStatus.NOT_VERIFIED]: "Non vérifié",
    },
  },
};

export type DeliveryPointLocale = typeof deliveryPointLocale;
export default deliveryPointLocale;

/*
- description
- status
-
 */
